var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPhone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9455 20.7245C26.2325 20.9995 26.508 21.2865 26.771 21.584C27.7495 22.6925 26.707 23.031 25.6315 22.917C23.487 22.6895 21.604 21.283 20.3345 19.54C20.0505 19.15 19.785 18.629 20.0255 18.2105C20.285 17.7585 20.938 17.7645 21.4405 17.901C22.1625 18.097 22.838 18.4375 23.477 18.8265C24.3655 19.3675 25.195 20.005 25.9455 20.7245Z",
    fill: "#FA532E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.521 7.84346C12.717 8.22246 12.8915 8.61146 13.033 9.01396C13.3145 9.81446 12.936 10.4215 12.0845 9.97446C10.1615 8.96496 8.8235 7.08996 7.9365 5.10696C7.79 4.77996 7.654 4.40096 7.8015 4.07446C7.9415 3.76546 8.3095 3.60746 8.648 3.62946C8.9865 3.65096 9.298 3.81946 9.576 4.01396C10.445 4.62196 11.0825 5.50096 11.6605 6.39046C11.967 6.86196 12.263 7.34396 12.521 7.84346Z",
    fill: "#FA532E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.103 9.49609C9.103 9.49609 11.407 16.2121 22.4355 21.1496",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.368 10.8084C10.368 10.8084 14.7735 10.7544 12.5735 7.3984C10.3735 4.0424 8.8825 3.5319 8.6015 3.5004C8.32 3.4689 3.3665 5.2999 5.736 12.3259C8.1055 19.3519 19.3375 25.2929 23.2005 25.8144C25.9405 25.9619 27.936 22.7609 26.689 21.3059C25.442 19.8509 22.8225 17.3979 21.16 17.7304C21.16 17.7304 19.7115 18.2219 19.7755 19.8144",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1205 25.7344C20.1205 25.7344 15.524 30.5479 13.189 27.1549C10.854 23.7619 17.639 25.0399 13.013 27.9039C8.387 30.7679 7.0205 26.5379 9.8405 25.2604C12.6605 23.9824 10.5455 29.4019 7.0205 28.4329C3.4955 27.4634 5.6545 25.7454 5.6545 25.7454",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon-phone.8f4741472c2486a7c196afd784d506c7.svg";
export { ForwardRef as ReactComponent };